import { useMutation, useQueryClient } from '@tanstack/react-query';
import { buyRequestApi } from '@entities/buy-request';
import { useToast } from '@shared/ui';
import type { UUID } from '@shared/api';

export function useHideBuyRequest(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (reason: string) => buyRequestApi.hide(id, reason),
    onSuccess: () => {
      toast.success('Заявка скрыта');
      void qc.invalidateQueries({ queryKey: ['buy-request', id] });
      void qc.invalidateQueries({ queryKey: ['buy-requests'] });
    },
    onError: (e: Error) => toast.error('Не удалось скрыть', e.message),
  });
}

export function useUnhideBuyRequest(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: () => buyRequestApi.unhide(id),
    onSuccess: () => {
      toast.success('Заявка восстановлена');
      void qc.invalidateQueries({ queryKey: ['buy-request', id] });
      void qc.invalidateQueries({ queryKey: ['buy-requests'] });
    },
    onError: (e: Error) => toast.error('Не удалось восстановить', e.message),
  });
}
